export default "__VITE_ASSET__8c735288__"